import { useContext } from 'react';

import { ReviewDetailsContext } from './ReviewDetailsContext';

export const useReviewDetailsContext = () => {
  const context = useContext(ReviewDetailsContext);

  return context;
};
